import { ReactNode } from "react";
import CaseBlockTitle from "../../common/case-block-title/case-block-title";
import "./cases-about-block.sass";

type Props = {
  children: ReactNode;
  title?: string;
};

const CasesAboutBlock = ({ children, title = "О проекте" }: Props) => {
  return (
    <div className="cases-about-block">
      <CaseBlockTitle>{title}</CaseBlockTitle>

      <div className="cases-about-block__text">{children}</div>
    </div>
  );
};

export default CasesAboutBlock;
